import { IDriverService } from './interfaces'
import {
  GetDriverListUseCase,
  GetDriverDetailsUseCase,
  GetDriverPerformanceUseCase,
  GetDriverOnlineTimeUseCase,
} from '../useCases/DriverUseCases'
import {
  GetDriverListUseCaseRequest,
  GetDriverDetailsUseCaseRequest,
  GetDriverPerformanceUseCaseRequest,
} from '../useCases/interfaces'
import { Result, createOk, createErr, isOk } from '@/shared/utils/Result'
import { Driver } from '@/core/domain/entities/Driver'

export class DriverService implements IDriverService {
  constructor(
    private readonly getDriverListUseCase: GetDriverListUseCase,
    private readonly getDriverDetailsUseCase: GetDriverDetailsUseCase,
    private readonly getDriverPerformanceUseCase: GetDriverPerformanceUseCase,
    private readonly getDriverOnlineTimeUseCase: GetDriverOnlineTimeUseCase
  ) {}

  async getDriverList(
    request: GetDriverListUseCaseRequest
  ): Promise<Result<Driver[], Error>> {
    return await this.getDriverListUseCase.execute(request)
  }

  async getDriverDetails(
    request: GetDriverDetailsUseCaseRequest
  ): Promise<Result<Driver, Error>> {
    return await this.getDriverDetailsUseCase.execute(request)
  }

  async getDriverPerformance(
    request: GetDriverPerformanceUseCaseRequest
  ): Promise<Result<Driver, Error>> {
    return await this.getDriverPerformanceUseCase.execute(request)
  }

  async getDriverOnlineTime(request: {
    userId: string
    driverId: string
    dateStart: string
    dateEnd: string
  }): Promise<
    Result<
      { onlineTime: number; diasOnline: number; tempoMedioPorDia: number },
      Error
    >
  > {
    const result = await this.getDriverOnlineTimeUseCase.execute(request)

    if (!isOk(result)) {
      return createErr(result.error)
    }

    return createOk({
      onlineTime: result.value.tempoTotal,
      diasOnline: result.value.diasOnline,
      tempoMedioPorDia: result.value.tempoMedioPorDia,
    })
  }
}
